module.exports = __webpack_public_path__ + "img/level3addon_mining_hands.2a35a057.png";